<div class="users-header">
  <ag-breadcrumb currentPath="All users" [bold]="true"></ag-breadcrumb>
</div>
<div style="position: absolute; top: 24px; right: 24px">
  <div></div>
  <ag-button-v2 color="green" label="New user" (click)="createNew()"></ag-button-v2>
</div>
<div class="agentList" *ngIf="agents">
  <table>
    <tr>
      <th class="headIndex">#</th>
      <th>Username</th>
      <th>First name</th>
      <th>Last name</th>
      <th>Phone number</th>
      <th>Tenant</th>
      <th>Access</th>
      <th>Last updated</th>
      <th></th>
    </tr>
    <tr *ngFor="let item of agents; let i = index" class="white-row" on-mouseover="hoveredIndex = i" on-mouseleave="hoveredIndex = -1">
      <td class="rowIndex">{{ i + 1 }}</td>
      <td>{{ item.Identifier }}</td>
      <td>{{ item.FirstName }}</td>
      <td>{{ item.LastName }}</td>
      <td>{{ item.TenantId }}</td>
      <td>{{ item.TenantName }}</td>
      <td>{{ formatAccess(item.Context) }}</td>
      <td style="width: 12%">
        {{ formatTimestamp(item.Timestamp) }}
      </td>
      <td style="padding: 10px !important">
        <img *ngIf="i === hoveredIndex" [src]="iconService.Icon.trash_can_red" (click)="onDeleteClick(item.Identifier)" />
        <div *ngIf="i !== hoveredIndex" style="width: 36px"></div>
      </td>
    </tr>
  </table>
</div>

<div *ngIf="showDelete" class="modal-window" (click)="closeDelete()">
  <div class="modal-content" (click)="childClick($event)">
    <h2 class="h2-medium">
      Are you sure you wish to delete

      <b class="h2-medium">{{ deleteAgent.FirstName }} {{ deleteAgent.LastName }}'s</b>
      Zest user?
    </h2>
    <div style="display: flex; gap: 12px">
      <ag-button-v2 (click)="confirmDelete()" specificWidth="200px" [destructive]="true" label="Delete user"></ag-button-v2>
      <ag-button-v2 (click)="closeDelete()" type="secondary" label="Cancel"></ag-button-v2>
    </div>
  </div>
</div>
